import React from 'react';
import { Container } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './SignupGridSkeleton.css'

function SignupGridSkeleton() {
  return (
    <Container>
      <div className={s.serviceProviderSkeletonContainer}>
        <div className={s.serviceProviderSkeletonWrapper}>
          <div>
            <Skeleton className={s.serviceProviderSkeletonHeading} />
            <Skeleton className={s.serviceProviderSkeletonContent} />
            <div className={s.serviceProviderSkeletonBtnGrp}>
              <Skeleton className={s.serviceProviderSkeletonBtn} />
              <Skeleton className={s.serviceProviderSkeletonBtn} />
            </div>
          </div>
          <div className={s.serviceProviderSkeletonImgContainer}>
            <Skeleton className={s.serviceProviderSkeletonImg} />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default withStyles(s)(SignupGridSkeleton);
